export default __webpack_public_path__ + "static/media/fun-facts1.4636a760.png";